module.exports = __webpack_public_path__ + "media/explosion-2.d0706c38.webm";